import React from 'react';

import Loader from '../../atoms/loader';
import List from './list';
import IntersectBox from '../../atoms/intersect-box';

const InfinityList = ({
    callbackFunction,
    loading,
    items,
    ItemComponent,
    targetPath,
    itemProps,
    listClassName,
    isDisabled,
    ...rest
}) => {
    return (
        <>
            <section {...rest}>
                <List
                    listClassName={listClassName}
                    ItemComponent={ItemComponent}
                    items={items}
                    path={targetPath}
                    itemProps={itemProps}
                    loading={loading}
                />
                {!isDisabled && (
                    <IntersectBox onIntersecting={callbackFunction}>
                        {loading && <Loader />}
                    </IntersectBox>
                )}
            </section>
        </>
    );
};

export default InfinityList;
